import { useDialog } from "hooks/useDialog";
import { Sizes } from "enums/sizes";
import { useCallback, useState } from "react";
import { NsKey } from "enums/NsKey";
import { useTranslation } from "react-i18next";
import SendingEmailContent from "./SendingEmailContent";

interface SendDevisDialogOptions {
  emailTo: string[];
  docsToSend: any[];
  initBody?: string;
  changeStatut?: boolean;
  object?: string;
  context?: string;
}

export const useSendDevisDialog = ({
  initBody,
  emailTo,
  docsToSend,
  changeStatut,
  object = 'Envoi du document',
  context = 'Contrat',
}: SendDevisDialogOptions) => {
  const { t } = useTranslation(NsKey.Common);
  const { openDialog, closeDialog } = useDialog();

  const openSearchDocument = useCallback(() => {
  }, []);

  const openSendEmail = useCallback(() => {
    openDialog(
      {
        title: t("Envoi d'email"),
        size: Sizes.xl,
      },
      <SendingEmailContent
        emailTo={emailTo}
        docsToSend={docsToSend}
        object={object}
        changeStatut={changeStatut}
        changeActiveView={openSearchDocument}
        initBody={initBody}
        onClose={closeDialog}
      />
    );
  }, [t, openDialog, closeDialog, emailTo, docsToSend, object, changeStatut, initBody, openSearchDocument]);

  const openSendDevisDialog = useCallback(() => {
    openSendEmail();
  }, [openSendEmail]);

  return {
    openSendDevisDialog,
  };
};
